import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	stroke: "#061178",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m4.583 19.372 3.377-7.878a.626.626 0 0 0-.574-.871h-2.47a.624.624 0 0 1-.574-.873L8.167 1a.625.625 0 0 1 .572-.375h6.417a.625.625 0 0 1 .487 1.016L12.268 5.86a.625.625 0 0 0 .489 1.015h2.818a.625.625 0 0 1 .442 1.067L4.583 19.372Z" }) }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 0h20v20H0z" })
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20stroke%3D%22%23061178%22%3E%3Cg%3E%3Cpath%20d%3D%22m4.583%2019.372%203.377-7.878a.626.626%200%200%200-.574-.871h-2.47a.624.624%200%200%201-.574-.873L8.167%201a.625.625%200%200%201%20.572-.375h6.417a.625.625%200%200%201%20.487%201.016L12.268%205.86a.625.625%200%200%200%20.489%201.015h2.818a.625.625%200%200%201%20.442%201.067L4.583%2019.372Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h20v20H0z%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
